import { Field, Input, Label } from '@headlessui/react'
import { cx } from 'class-variance-authority'
import React from 'react'
import { useApplyFormStore } from '../../stores/ui/applyFormStore'
import { ErrorMessage } from '../ui/form'

interface StartDateInputProps {
  error?: string
  name?: string
  colorCareerSite?: string
  isCareerSiteApply?: boolean
}

export const StartDateInput = ({
  error,
  name,
  colorCareerSite,
  isCareerSiteApply,
}: StartDateInputProps) => {
  const isDirty = useApplyFormStore((state) => state.isDirty)
  const { setFieldValue } = useApplyFormStore()

  return (
    <Field className="flex flex-col space-y-2">
      <Label htmlFor={name} className="font-medium text-night text-sm/6">
        Quand souhaitez-vous débuter ?
      </Label>
      <Input
        className={cx(
          'bg-white border-2 border-gray-200 rounded-xl disabled:cursor-not-allowed placeholder:text-sm text-sm focus:outline-none focus-visible:outline-none focus:ring-0 focus-visible:ring-0 relative placeholder:text-night/60 text-night',
          Boolean(error) && 'border-red-300',
        )}
        id={name}
        name={name}
        type="date"
        lang="fr-FR"
        value={useApplyFormStore((state) => state.startDate) || undefined}
        onChange={(e) => {
          setFieldValue('startDate', e.target.value)
        }}
        style={{
          color:
            isCareerSiteApply && colorCareerSite ? colorCareerSite : undefined,
        }}
      />
      {isDirty && <ErrorMessage error={error} />}
    </Field>
  )
}
